// App-icon badge: the red number on the home-screen icon
// mirrors the SAME count as the in-app Requests-tab badge (/orders/new —
// pending + queued paid requests). The server stamps the count onto every
// push (aps.badge), so the icon updates while the app is closed; this module
// reconciles it from live data whenever the app is open, and clears it on
// logout so a signed-out phone never shows a stale count.
//
// Static import ON PURPOSE — webpack dynamic-import chunks silently never
// load inside the Capacitor WKWebView (see nativePush.ts). The plugin shim is
// tiny and every call guards on isNativePlatform().
import { Capacitor } from "@capacitor/core";
import { Badge } from "@capawesome/capacitor-badge";

const IS_NATIVE = Capacitor.isNativePlatform();

/** Set the icon badge to `count` (0 clears it). Never throws — the badge is
 *  cosmetic and must not break the caller's data flow. */
export async function setAppBadge(count: number): Promise<void> {
  if (!IS_NATIVE) return;
  try {
    if (count > 0) {
      await Badge.set({ count });
    } else {
      await Badge.clear();
    }
  } catch {
    // Badge permission not granted (rides along with the push permission) or
    // plugin unavailable — silently skip.
  }
}
